<template>
  <el-dialog
    :close-on-click-modal="false"
    title="修改"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="140px"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  driverSalaryUploadFile,
} from 'api/getPay';
import {
  getFileUrl,
} from 'api';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '附件',
            value: 'files',
            type: 'img',
            accept: 'image/*',
            default: [],
          },
        ],
        rules: { // 表单验证规则
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.getDetailLoading = true;
      this.$nextTick(async () => {
        this.$refs.customForm.reset();
        this.originData = item;
        if (item.salaryFiles) {
          const files = [];
          const imgRes = await getFileUrl({
            flowIds: item.salaryFiles,
          });
          imgRes.items.forEach((item) => {
            files.push({
              id: item.flowId,
              url: item.fullPath,
            });
          });
          this.getDetailLoading = false;
          this.$refs.customForm.setVal('files', files);
        } else {
          this.getDetailLoading = false;
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const files = form.files.map((item) => item.id);
      const res = await driverSalaryUploadFile({
        salaryId: this.originData.salaryId,
        files: files.join(','),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
